module.exports = __webpack_public_path__ + "static/media/cart-arrow-down.08d4a455.svg";